import { IPrismicImage } from '@monofront/types';
import { HERO_BANNER_TYPE, HeroBannerProps, IHeroBanner } from './types';

export const mapHeroBanner = ({
  prismicContent,
}: {
  prismicContent: HeroBannerProps['slice'];
}): IHeroBanner => {
  const { primary } = prismicContent;

  const {
    bgdesktopimg: bgDesktopImg,
    bgmobileimg: bgMobileImg,
    cta_desc: ctaDesc,
    cta_label: ctaLabel,
    cta_link: ctaLink,
    desc,
    title,
    type,
    cta_label_finish_subscription: ctaLabelFinishSubscription,
  } = primary;

  const heroBanner: IHeroBanner = {
    bgDesktopImg: bgDesktopImg as IPrismicImage,
    bgMobileImg: bgMobileImg as IPrismicImage,
    ctaDesc,
    ctaLabel: ctaLabel as string,
    ctaLink,
    desc,
    title,
    ctaLabelFinishSubscription: ctaLabelFinishSubscription as string,
    type: type as HERO_BANNER_TYPE,
  };

  return heroBanner;
};
